import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { createIntl } from "@formatjs/intl/lib/src/create-intl";
import React, { createContext, useContext, useMemo } from "react";
import { DEFAULT_LOCALE_KEY } from "../consts/DEFAULT_LOCALE";
import { createFormatMessage } from "./createFormatMessage";
import { buildLocale } from "./utils";
var getFormatMessage = function getFormatMessage(localeKey, formatMessage) {
  if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID || (localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
    return createFormatMessage(localeKey, formatMessage);
  }
  return formatMessage;
};
var buildIntl = function buildIntl(_ref) {
  var localeKey = _ref.localeKey,
    messages = _ref.messages;
  var locale = buildLocale(localeKey !== null && localeKey !== void 0 ? localeKey : DEFAULT_LOCALE_KEY);
  var intl = createIntl({
    locale: locale,
    defaultLocale: locale,
    messages: messages
  });
  var formatMessage = getFormatMessage(localeKey, intl.formatMessage);
  return _objectSpread(_objectSpread({}, intl), {}, {
    formatMessage: formatMessage
  });
};
var DEFAULT_INTL = buildIntl({
  localeKey: DEFAULT_LOCALE_KEY,
  messages: {}
});
var DEFAULT_STORE = {
  intl: buildIntl({
    localeKey: DEFAULT_LOCALE_KEY,
    messages: {}
  }),
  shouldPassThrough: false,
  localeKey: DEFAULT_LOCALE_KEY,
  currencyFormatLocale: DEFAULT_INTL.locale,
  intlForCurrency: DEFAULT_INTL
};
var LocalizationContext = /*#__PURE__*/createContext(DEFAULT_STORE);
export var LocalizationProvider = function LocalizationProvider(_ref2) {
  var children = _ref2.children,
    localeKey = _ref2.localeKey,
    currencyFormatLocale = _ref2.currencyFormatLocale,
    shouldPassThrough = _ref2.shouldPassThrough;
  var initialValue = useMemo(function () {
    var _ref3, _ref4, _ref5;
    var value = _objectSpread({}, DEFAULT_STORE);
    value.localeKey = (_ref3 = localeKey !== null && localeKey !== void 0 ? localeKey : getGlobalProperty("localeKey")) !== null && _ref3 !== void 0 ? _ref3 : value.localeKey;
    value.shouldPassThrough = shouldPassThrough !== null && shouldPassThrough !== void 0 ? shouldPassThrough : value.shouldPassThrough;
    value.intl = value.localeKey ? buildIntl({
      localeKey: value.localeKey,
      messages: {}
    }) : value.intl;
    value.currencyFormatLocale = (_ref4 = (_ref5 = currencyFormatLocale !== null && currencyFormatLocale !== void 0 ? currencyFormatLocale : getGlobalProperty("currencyFormatLocale")) !== null && _ref5 !== void 0 ? _ref5 : value.currencyFormatLocale) !== null && _ref4 !== void 0 ? _ref4 : value.intl.locale;
    value.intlForCurrency = value.currencyFormatLocale !== value.intl.locale ? createIntl({
      locale: value.currencyFormatLocale,
      messages: {}
    }) : value.intl;
    return value;
  }, [currencyFormatLocale, localeKey, shouldPassThrough]);
  return /*#__PURE__*/React.createElement(LocalizationContext.Provider, {
    value: initialValue
  }, children);
};
export var useLocalization = function useLocalization() {
  return useContext(LocalizationContext);
};